import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, AlertCircle } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";
import { api, formatApiError } from "@/lib/api";
import Seo from "@/seo/Seo";

export default function AlertsUnsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ kind: "loading", message: "" });

  useEffect(() => {
    if (!token) {
      setState({ kind: "err", message: "Missing unsubscribe token" });
      return;
    }
    api
      .get(`/alerts/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(() => setState({ kind: "ok", message: "You've been unsubscribed. No more emails from this alert." }))
      .catch((e) => setState({ kind: "err", message: formatApiError(e) }));
  }, [token]);

  return (
    <>
      <Seo title="Unsubscribed — Floor-Match" path="/alerts/unsubscribe" robots="noindex, nofollow" />
      <PublicHeader />
      <main className="min-h-screen fm-grain flex items-start justify-center pt-20 px-4">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-8 text-center">
          {state.kind === "loading" && <p className="text-slate-600">Unsubscribing…</p>}
          {state.kind === "ok" && (
            <>
              <CheckCircle2 className="w-10 h-10 text-[#2A5A3B] mx-auto mb-3" />
              <h1 className="font-display font-bold text-2xl text-slate-900">Unsubscribed</h1>
              <p className="text-slate-600 mt-2">{state.message}</p>
              <Link to="/" className="fm-btn-primary inline-block mt-6">
                Back to Floor-Match
              </Link>
            </>
          )}
          {state.kind === "err" && (
            <>
              <AlertCircle className="w-10 h-10 text-[#E05915] mx-auto mb-3" />
              <h1 className="font-display font-bold text-2xl text-slate-900">Couldn't unsubscribe</h1>
              <p className="text-slate-600 mt-2">{state.message}</p>
              <Link to="/" className="fm-btn-primary inline-block mt-6">
                Back to Floor-Match
              </Link>
            </>
          )}
        </div>
      </main>
    </>
  );
}
